const translations = {
    actionsLabel: 'Controller actions',
    delete: 'Delete',
    deleteError: 'Controller could not be deleted.',
    deleteSuccess: 'Controller deleted.',
    edit: 'Edit',
    emptyDescription: 'Add a controller to see it listed here.',
    emptyHeading: 'No controllers yet',
    loadError: 'Controllers could not be loaded.',
    loadMore: 'Load more',
    make: 'Make',
    model: 'Model',
    name: 'Name',
    serialNumber: 'Serial Number',
    tableLabel: 'Controllers'
};

export default translations;
